<div class="auth login d-flex">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">

        <div class="login-header text-center">
          <img src="/assets/img/videobyte-logo.svg" alt="" width="200"/>
        </div>

        <div class="login-content">
          <mat-card class="p-5 mb-5">
            <mat-card-title class="mb-4 pb-3 text-center">
              <i class="fal fa-user-circle fa-3x mb-3 d-block text-primary" aria-hidden="true"></i>
              <strong>Sign in to VideoByte</strong>
            </mat-card-title>
            <mat-card-content>
              <div>
                <form #f="ngForm" class="d-flex flex-column">
                  <mat-form-field floatLabel="" class="mb-2" appearance="outline">
                    <mat-label>Email</mat-label>
                    <input #email
                           matInput
                           placeholder="Registered email address"
                           name="email" value=""
                           required
                           email
                           [(ngModel)]="user.email"
                           (keyup.enter)="f.valid &&  login()">
                  </mat-form-field>
                  <mat-form-field floatLabel=""appearance="outline" >
                    <mat-label>Password</mat-label>
                    <input type="password"
                           matInput
                           name="password"
                           placeholder="Password"
                           value=""
                           required
                           [(ngModel)]="user.password" (keyup.enter)=" f.valid && login()">
                    <!--<mat-hint align="end">Forgot password? <a [routerLink]="'/forgot-password'">Click here</a></mat-hint>-->
                  </mat-form-field>
                </form>
              </div>
              <p class="link" [routerLink]="'/forgot-password'">Forgot your password?</p>
            </mat-card-content>
            <mat-card-footer class="text-center d-flex flex-column">
              <button type="button" mat-flat-button color="primary" class="iconed large" (click)="login()"
                      [disabled]="!f.valid">
                <i class="far fa-sign-in"></i>
                <span>Sign in</span>
              </button>
              <button *ngIf="oktaSsoEnabled"
                      type="button"
                      mat-stroked-button
                      color="primary"
                      class="iconed large mt-3"
                      (click)="loginWithOkta()">
                <i class="far fa-key"></i>
                <span>Sign in with Kargo SSO</span>
              </button>
            </mat-card-footer>
          </mat-card>

          <small class="d-block text-center text-white mt-n3" [hidden]="!registerLinkVisible">
            Not a member yet? <a class="text-info" [routerLink]="'/register'">Register here</a>
          </small>

        </div>

      </div>
    </div>
  </div>
</div>
